import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget } from '@eforall/dashboard';
import { AppService } from '../../../../../services';
import { VolunteerDialogDataService } from '../volunteer-dialog-data.service';
import { getSetup } from './grid/get-setup';

@Component({
	selector: 'volunteer-mentor-signups-dialog-part',
	standalone: true,
	imports: [
		GridContentWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './mentor-signups-dialog.part.html',
})
export class VolunteerMentorSignupsDialogPart {

	public dialogBodyHeight = input.required<number>();

	private readonly util = inject(UtilityService);
	private readonly dialogService = inject(DialogService);
	public readonly dialogDataService = inject(VolunteerDialogDataService);
	private app = inject(AppService);

	public setup = getSetup(this.util, this.app, this.dialogService, this.dialogDataService);

	// subtracting 70 to account for padding, tabstrip
	public customHeight = computed(() => this.dialogBodyHeight() - 70);

	public mentorSignups = computed(() => this.dialogDataService.volunteerDetails()?.mentorSignups ?? []);


}
